/**
 * Liste blanche pour l’outil d’édition des images de parcours.
 * Seuls les emails (ou UID) listés peuvent accéder à /dashboard/parcours-images.
 * Variable d’environnement : VITE_PARCOURS_EDITOR_EMAIL (une adresse ou plusieurs séparées par des virgules).
 */

const fromEnv = typeof import.meta !== 'undefined' && import.meta.env?.VITE_PARCOURS_EDITOR_EMAIL
  ? String(import.meta.env.VITE_PARCOURS_EDITOR_EMAIL).split(',').map((s) => s.trim()).filter(Boolean)
  : []

/** Emails autorisés à utiliser l’outil parcours-images (env + liste en dur si besoin). */
export const PARCOURS_EDITOR_ALLOWED_EMAILS = fromEnv.length > 0 ? fromEnv : []

/**
 * Vérifie si l’utilisateur courant peut accéder à l’outil.
 * @param {string|null|undefined} email - user.email
 * @param {string|null|undefined} uid - user.uid (optionnel, pour allowlist UID plus tard)
 * @returns {boolean}
 */
export function canAccessParcoursImagesEditor(email, uid = null) {
  if (!email && !uid) return false
  if (PARCOURS_EDITOR_ALLOWED_EMAILS.length === 0) return false
  if (email && PARCOURS_EDITOR_ALLOWED_EMAILS.includes(email)) return true
  return false
}

/**
 * Liste blanche pour l'affichage des crédits API (usage YouTube / Gemini).
 * Variable d'environnement : VITE_API_USAGE_VIEWER_EMAIL (une adresse ou plusieurs séparées par des virgules).
 */
const apiUsageViewerFromEnv = typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_USAGE_VIEWER_EMAIL
  ? String(import.meta.env.VITE_API_USAGE_VIEWER_EMAIL).split(',').map((s) => s.trim()).filter(Boolean)
  : []

/** Emails autorisés à voir le bloc « Crédits API » sur le Dashboard. */
export const API_USAGE_VIEWER_EMAILS = apiUsageViewerFromEnv.length > 0 ? apiUsageViewerFromEnv : []

/**
 * Vérifie si l'utilisateur peut voir l'affichage des crédits API restants.
 * @param {string|null|undefined} email - user.email
 * @param {string|null|undefined} uid - user.uid (optionnel)
 * @returns {boolean}
 */
export function canViewApiUsage(email, uid = null) {
  if (!email && !uid) return false
  if (API_USAGE_VIEWER_EMAILS.length === 0) return false
  if (email && API_USAGE_VIEWER_EMAILS.includes(email)) return true
  return false
}

/**
 * Liste blanche pour l'éditeur Codex admin.
 * Variable d'environnement : VITE_CODEX_ADMIN_EMAIL (une adresse ou plusieurs séparées par des virgules).
 */
const codexAdminFromEnv = typeof import.meta !== 'undefined' && import.meta.env?.VITE_CODEX_ADMIN_EMAIL
  ? String(import.meta.env.VITE_CODEX_ADMIN_EMAIL).split(',').map((s) => s.trim()).filter(Boolean)
  : []

/** Emails autorisés à accéder à l'interface d'administration du Codex. */
export const CODEX_ADMIN_EMAILS = codexAdminFromEnv.length > 0 ? codexAdminFromEnv : []

/**
 * Vérifie si l'utilisateur peut accéder à l'administration du Codex.
 * @param {string|null|undefined} email - user.email
 * @param {string|null|undefined} uid - user.uid (optionnel)
 * @returns {boolean}
 */
export function canAccessCodexAdmin(email, uid = null) {
  if (!email && !uid) return false
  if (CODEX_ADMIN_EMAILS.length === 0) return false
  if (email && CODEX_ADMIN_EMAILS.includes(email)) return true
  return false
}
